/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';

import { Button } from 'components/ui';
import IconMessageCircle from 'components/ui/icons/IconMessageCircle';
import { CONFIG } from 'constants/config';
import { useChatDispatchHelpers, useChatStore } from 'context/ChatContext';
import { removeRoPrefix } from 'helpers/PhoneNumberHelpers';
import { cx } from 'helpers/StylingHelpers';
import { useTranslation } from 'hooks/common/useTranslation';
import { useUser } from 'hooks/data/useUser';

import styles from './ChatButton.module.scss';

const ChatButton = () => {
  if (!CONFIG.SALESFORCE.CHAT.IS_ENABLED) return null;

  const {
    buttonProps,
    isButtonVisible,
    isLoading,
    isAgentAvailable,
    context
  } = useChatStore();

  // Hooks

  const { t } = useTranslation();

  const { startChat } = useChatDispatchHelpers();
  const { data: user } = useUser({}, { enabled: isButtonVisible });

  // Handlers

  const onClick = () => {
    startChat({
      name: user?.fullName,
      email: user?.email,
      phone: removeRoPrefix(user?.phoneNumber),
    }, context);
  };

  // Empty

  if (!isButtonVisible) return null;

  // Render

  return (
    <Button
      id="chat-button"
      className={
        cx(
          styles.root,
          { [styles.offline]: !isAgentAvailable },
          { [buttonProps?.className]: buttonProps?.className }
        )
      }
      variant="primary"
      disabled={!isAgentAvailable}
      loading={isLoading}
      onClick={onClick}
    >
      <div className={styles.content}>
        <IconMessageCircle className={styles.icon} />
        <div className={styles.label}>{isAgentAvailable ? t('CHAT.DEFAULT_MINIMIZED_TEXT') : 'Agent offline'}</div>
      </div>
    </Button>
  );
};

export default ChatButton;
